import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import { useCallback } from 'react';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import AsyncIFrame from 'collaboration-sidebar/components/AsyncUIIFrame';
import { IS_OPEN, TAB } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import { IFRAME_INIT_TIMEOUT } from 'collaboration-sidebar/constants/iframe';
import { useCollaborationSidebarState } from 'collaboration-sidebar/hooks';
import useCollaborationSidebarProps from 'collaboration-sidebar/hooks/useCollaborationSidebarProps';
import { useIsTabParentRendered } from 'collaboration-sidebar/hooks/useIsTabParentRendered';
import ParentRenderedContent from 'collaboration-sidebar/components/ParentRenderedContent';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { getEmbeddablePanelUrl } from 'collaboration-sidebar/utils/urls';
import ErrorMessage from 'collaboration-sidebar/components/errors/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import useHasNavCopilot from 'collaboration-sidebar/features/copilot/hooks/useHasNavCopilot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollaborationSidebarContent(t0) {
  "use memo";

  const $ = _c(47);
  const {
    isOpen: t1,
    iframeShouldRender: t2
  } = t0;
  const isOpen = t1 === undefined ? true : t1;
  const iframeShouldRender = t2 === undefined ? true : t2;
  const {
    scrollablePage,
    isOverlay,
    objectType,
    enabledFeatures,
    appName,
    ApprovalsContent,
    embeddedCommentsProps,
    commentableAssets,
    assetName,
    commentableAssetsTitle,
    isListingPage,
    objectId,
    hasUnreadComments,
    hasSidebarPermission,
    iframe: t3,
    onMessageRef,
    commentingDisabled,
    showSidebarHeader,
    hideCommentModeAndToggle,
    isLoadingFAS,
    embeddedCommentIndicatorOverride
  } = useCollaborationSidebarProps();
  const {
    handleSidebarInitError,
    isReady,
    handleReady,
    handleSidebarReadyError,
    IFrameError
  } = t3;
  const hasNavCopilot = useHasNavCopilot();
  const {
    tab,
    ctaUrl,
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  let t4;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t4 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: false
      });
    };
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleClose = t4;
  let t5;
  if ($[2] !== handleClose || $[3] !== onMessageRef) {
    t5 = message => {
      if (message.payload.type === MSG_TYPE_MODAL_DIALOG_CLOSE) {
        handleClose();
      } else {
        if (onMessageRef.current) {
          onMessageRef.current(message);
        }
      }
    };
    $[2] = handleClose;
    $[3] = onMessageRef;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleOnMessage = t5;
  const isTabParentRendered = useIsTabParentRendered(tab);
  if (!isLoadingFAS && !hasSidebarPermission) {
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = /*#__PURE__*/_jsx(View, {
        padding: "300",
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          illustration: "keys",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "collaborationSidebar.noSidebarPermission.title"
          }),
          message: "collaborationSidebar.noSidebarPermission.message"
        })
      });
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    return t6;
  }
  let t6;
  if ($[6] !== ApprovalsContent || $[7] !== enabledFeatures || $[8] !== isOpen || $[9] !== tab) {
    t6 = /*#__PURE__*/_jsx(ParentRenderedContent, {
      show: isOpen,
      tab: tab,
      enabledFeatures: enabledFeatures,
      ApprovalsContent: ApprovalsContent
    });
    $[6] = ApprovalsContent;
    $[7] = enabledFeatures;
    $[8] = isOpen;
    $[9] = tab;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== IFrameError || $[12] !== isOpen || $[13] !== isReady) {
    t7 = isOpen && !isReady && !IFrameError && /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      inlineSize: "100%",
      position: "absolute",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-test-id": "sidebar-content-loading-spinner",
        layout: "centered"
      })
    });
    $[11] = IFrameError;
    $[12] = isOpen;
    $[13] = isReady;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== appName || $[16] !== assetName || $[17] !== collaborationSidebarState || $[18] !== commentableAssets || $[19] !== commentableAssetsTitle || $[20] !== commentingDisabled || $[21] !== ctaUrl || $[22] !== embeddedCommentIndicatorOverride || $[23] !== embeddedCommentsProps || $[24] !== enabledFeatures || $[25] !== handleOnMessage || $[26] !== handleReady || $[27] !== handleSidebarInitError || $[28] !== handleSidebarReadyError || $[29] !== hasNavCopilot || $[30] !== hasUnreadComments || $[31] !== hideCommentModeAndToggle || $[32] !== iframeShouldRender || $[33] !== isListingPage || $[34] !== isOpen || $[35] !== isOverlay || $[36] !== isReady || $[37] !== isTabParentRendered || $[38] !== objectId || $[39] !== objectType || $[40] !== scrollablePage || $[41] !== showSidebarHeader) {
    t8 = iframeShouldRender && /*#__PURE__*/_jsx(AsyncIFrame, {
      embeddedPassthruProps: {
        collaborationSidebarState,
        commentableAssets,
        assetName,
        commentableAssetsTitle,
        isListingPage,
        enabledFeatures,
        hasUnreadComments,
        commentingDisabled,
        appSupportedRoutesRegex: embeddedCommentsProps && embeddedCommentsProps.appSupportedRoutesRegex,
        showSidebarHeader,
        hideCommentModeAndToggle,
        hasNavCopilot,
        embeddedCommentIndicatorOverride
      },
      height: "100%",
      iframePassthruProps: Object.assign({
        "data-test-id": "collaboration-sidebar-embedded-iframe",
        "data-iframe-ready": isReady,
        title: I18n.text("collaborationSidebar.panel.sidebarTitle"),
        "aria-hidden": !isOpen
      }, !isOpen ? {
        tabIndex: "-1"
      } : {}),
      initTimeout: IFRAME_INIT_TIMEOUT,
      name: "collaboration-sidebar",
      onInitError: handleSidebarInitError,
      onReady: handleReady,
      onReadyError: handleSidebarReadyError,
      scrollablePage: scrollablePage,
      isOverlay: isOverlay,
      src: getEmbeddablePanelUrl({
        objectType,
        objectId,
        ctaUrl,
        appName,
        tab: collaborationSidebarState[TAB],
        enabledFeatures
      }),
      appName: appName,
      onMessage: handleOnMessage,
      className: isTabParentRendered ? "hidden" : undefined
    });
    $[15] = appName;
    $[16] = assetName;
    $[17] = collaborationSidebarState;
    $[18] = commentableAssets;
    $[19] = commentableAssetsTitle;
    $[20] = commentingDisabled;
    $[21] = ctaUrl;
    $[22] = embeddedCommentIndicatorOverride;
    $[23] = embeddedCommentsProps;
    $[24] = enabledFeatures;
    $[25] = handleOnMessage;
    $[26] = handleReady;
    $[27] = handleSidebarInitError;
    $[28] = handleSidebarReadyError;
    $[29] = hasNavCopilot;
    $[30] = hasUnreadComments;
    $[31] = hideCommentModeAndToggle;
    $[32] = iframeShouldRender;
    $[33] = isListingPage;
    $[34] = isOpen;
    $[35] = isOverlay;
    $[36] = isReady;
    $[37] = isTabParentRendered;
    $[38] = objectId;
    $[39] = objectType;
    $[40] = scrollablePage;
    $[41] = showSidebarHeader;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  let t9;
  if ($[43] !== t6 || $[44] !== t7 || $[45] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      children: [t6, t7, t8]
    });
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  return t9;
}